import EcommerceHomePage from "./EcommerceHomePage";

export default EcommerceHomePage;
